import { createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, vModelText as _vModelText, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f2efeb0")

_pushScopeId("data-v-0f2efeb0")
const _hoisted_1 = { class: "card border-left-warning shadow mx-0 mb-4 animated fadeIn" }
const _hoisted_2 = { class: "card-header py-3 d-flex flex-row align-items-center justify-content-start" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-left" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, " User Details ", -1)
const _hoisted_5 = {
  key: 0,
  class: "card-body"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col text-right" }
const _hoisted_8 = { class: "btn btn-sm btn-warning ml-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_10 = { class: "mb-5 mt-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-male" }, null, -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_14 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Email")
], -1)
const _hoisted_15 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_16 = {
  key: 0,
  title: "Email confirmed",
  class: "text-success"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  })
], -1)
const _hoisted_18 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  })
], -1)
const _hoisted_20 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("b", null, "Date of Birth")
], -1)
const _hoisted_22 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_23 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createVNode("b", null, "Username")
], -1)
const _hoisted_25 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_28 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Occupation")
], -1)
const _hoisted_29 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_30 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_31 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Phone Number")
], -1)
const _hoisted_32 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_33 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_34 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "PEP")
], -1)
const _hoisted_35 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-lg-4 col-md-4 col-sm-12 col-12" }
const _hoisted_38 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Address Line 1")
], -1)
const _hoisted_39 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_40 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_41 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Street")
], -1)
const _hoisted_42 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_43 = { class: "col-lg-4 col-md-4 col-sm-6 col-6  " }
const _hoisted_44 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Province")
], -1)
const _hoisted_45 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_46 = { class: "col-lg-4 col-md-4 col-sm-6 col-6  " }
const _hoisted_47 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Postal Code")
], -1)
const _hoisted_48 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_49 = { class: "col-lg-4 col-md-4 col-sm-12 col-12" }
const _hoisted_50 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Address Line 2")
], -1)
const _hoisted_51 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_52 = { class: "col-lg-4 col-md-4 col-sm-12 col-12" }
const _hoisted_53 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "SignUp Date")
], -1)
const _hoisted_54 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_55 = { class: "row mt-3" }
const _hoisted_56 = { class: "col-12" }
const _hoisted_57 = { class: "d-flex justify-content-between" }
const _hoisted_58 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Files "),
  /*#__PURE__*/_createVNode("i", { class: "fas fa-folder-open" })
], -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" See Full History ")
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" No Files. ")
const _hoisted_61 = /*#__PURE__*/_createVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_62 = { class: "row mt-3" }
const _hoisted_63 = { class: "col-12" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Admin Updates "),
    /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
  ])
], -1)
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" No Updates. ")
const _hoisted_66 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_67 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_68 = {
  key: 2,
  class: "badge badge-danger"
}
const _hoisted_69 = {
  key: 3,
  class: "badge badge-success"
}
const _hoisted_70 = {
  key: 4,
  class: "badge badge-success"
}
const _hoisted_71 = { class: "row mt-4" }
const _hoisted_72 = { class: "col-4" }
const _hoisted_73 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Approve Account?")
], -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_75 = { class: "form-check form-check-inline" }
const _hoisted_76 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "yes-approve"
}, "Yes", -1)
const _hoisted_77 = { class: "form-check form-check-inline" }
const _hoisted_78 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "no-approve"
}, "No", -1)
const _hoisted_79 = { class: "col-8" }
const _hoisted_80 = {
  key: 0,
  class: "form-group"
}
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" Approve ")
const _hoisted_82 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"
  })
], -1)
const _hoisted_83 = {
  key: 0,
  class: "row"
}
const _hoisted_84 = { class: "col" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" Reject ")
const _hoisted_86 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12L20 6.91Z"
  })
], -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col" }, [
    /*#__PURE__*/_createVNode("hr")
  ])
], -1)
const _hoisted_89 = { class: "row" }
const _hoisted_90 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h6 text-left mb-3" }, [
    /*#__PURE__*/_createTextVNode(" Security Options "),
    /*#__PURE__*/_createVNode("i", { class: "fas fa-shield-alt" })
  ])
], -1)
const _hoisted_91 = { class: "col-12 text-left" }
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" Current Status:    ")
const _hoisted_93 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_94 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_95 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" Enable API token:    ")
const _hoisted_98 = { key: 2 }
const _hoisted_99 = /*#__PURE__*/_createVNode("span", { class: "badge badge-success" }, " Enabled ", -1)
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "fas fa-undo-alt" }, null, -1)
const _hoisted_101 = /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_102 = { key: 3 }
const _hoisted_103 = /*#__PURE__*/_createVNode("span", { class: "badge badge-warning" }, " Disabled", -1)
const _hoisted_104 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_105 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_106 = { key: 4 }
const _hoisted_107 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_108 = /*#__PURE__*/_createTextVNode(" Two-factor authentication:    ")
const _hoisted_109 = {
  key: 5,
  class: "badge badge-success"
}
const _hoisted_110 = {
  key: 6,
  class: "badge badge-warning"
}
const _hoisted_111 = /*#__PURE__*/_createVNode("i", { class: "fas fa-undo-alt" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("a", {
        href: "#",
        class: "text-dark mr-2",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"]))
      }, [
        _hoisted_3
      ]),
      _hoisted_4
    ]),
    (_ctx.selectedUser)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: {
							name: 'dashboard.add.user',
							params: { customerId: _ctx.selectedUser.id },
						}
              }, {
                default: _withId(() => [
                  _withDirectives(_createVNode("button", _hoisted_8, [
                    _hoisted_9
                  ], 512), [
                    [_directive_tooltip, 'Edit User']
                  ])
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createVNode("h4", _hoisted_10, [
            _createVNode("b", null, [
              _createTextVNode(_toDisplayString(_ctx.selectedUser.firstName) + " " + _toDisplayString(_ctx.selectedUser.lastName) + " ", 1),
              _hoisted_11
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode("h6", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.selectedUser.email) + " ", 1),
                (_ctx.selectedUser.emailConfirmed)
                  ? (_openBlock(), _createBlock("span", _hoisted_16, [
                      _hoisted_17
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_18, [
                      _hoisted_19
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode("h6", _hoisted_22, _toDisplayString(_ctx.selectedUser.dateOfBirth), 1)
            ]),
            _createVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode("h6", _hoisted_25, _toDisplayString(_ctx.selectedUser.nickname), 1)
            ])
          ]),
          _createVNode("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode("h6", _hoisted_29, _toDisplayString(_ctx.selectedUser.occupation || '---'), 1)
            ]),
            _createVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode("h6", _hoisted_32, _toDisplayString(_ctx.selectedUser.phoneNumber || '---'), 1)
            ]),
            _createVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode("h6", _hoisted_35, _toDisplayString(_ctx.selectedUser.relationWithGovernment ? 'Yes' : 'No'), 1)
            ])
          ]),
          _createVNode("div", _hoisted_36, [
            _createVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode("h6", _hoisted_39, _toDisplayString(_ctx.selectedUser.addressLine1 || '---'), 1)
            ]),
            _createVNode("div", _hoisted_40, [
              _hoisted_41,
              _createVNode("h6", _hoisted_42, _toDisplayString(_ctx.selectedUser.street || '---') + " " + _toDisplayString(_ctx.selectedUser.streetNumber) + " " + _toDisplayString(_ctx.selectedUser.interiorNumber
								? 'Int. ' + _ctx.selectedUser.interiorNumber
								: ''), 1)
            ]),
            _createVNode("div", _hoisted_43, [
              _hoisted_44,
              _createVNode("h6", _hoisted_45, _toDisplayString(_ctx.selectedUser.province || '---'), 1)
            ]),
            _createVNode("div", _hoisted_46, [
              _hoisted_47,
              _createVNode("h6", _hoisted_48, _toDisplayString(_ctx.selectedUser.postalCode || '---'), 1)
            ]),
            _createVNode("div", _hoisted_49, [
              _hoisted_50,
              _createVNode("h6", _hoisted_51, _toDisplayString(_ctx.selectedUser.addressLine2 || '---'), 1)
            ]),
            _createVNode("div", _hoisted_52, [
              _hoisted_53,
              _createVNode("h6", _hoisted_54, _toDisplayString(_ctx.formatDate(_ctx.selectedUser.createdAt)), 1)
            ])
          ]),
          _createVNode("div", _hoisted_55, [
            _createVNode("div", _hoisted_56, [
              _createVNode(_component_DataTable, {
                value: _ctx.filterFiles,
                autoLayout: true,
                filterDisplay: "menu"
              }, {
                header: _withId(() => [
                  _createVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createVNode(_component_router_link, {
                      to: {
										name: 'dashboard.file.history',
										params: { id: _ctx.selectedUser?.id },
									}
                    }, {
                      default: _withId(() => [
                        _hoisted_59
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]),
                empty: _withId(() => [
                  _hoisted_60
                ]),
                default: _withId(() => [
                  _createVNode(_component_Column, {
                    header: "Document",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.separeteByCapital(slotProps.data.typeOfDocument)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "uploadedAt",
                    header: "Uploaded At",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdAt)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Action",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createVNode("button", {
                        class: "btn btn-sm btn-primary",
                        onClick: ($event: any) => (_ctx.downloadDocument(slotProps.data))
                      }, [
                        _hoisted_61
                      ], 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createVNode("div", _hoisted_62, [
            _createVNode("div", _hoisted_63, [
              _createVNode(_component_DataTable, {
                value: _ctx.adminUpdates,
                responsiveLayout: true
              }, {
                header: _withId(() => [
                  _hoisted_64
                ]),
                empty: _withId(() => [
                  _hoisted_65
                ]),
                default: _withId(() => [
                  _createVNode(_component_Column, {
                    field: "admin.email",
                    header: "Email"
                  }),
                  _createVNode(_component_Column, { header: "Action" }, {
                    body: _withId((slotProps) => [
                      (slotProps.data.status === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_66, " Approved "))
                        : (slotProps.data.status === 3)
                          ? (_openBlock(), _createBlock("span", _hoisted_67, " Rejected "))
                          : (slotProps.data.status === 4)
                            ? (_openBlock(), _createBlock("span", _hoisted_68, " Baned "))
                            : (slotProps.data.status === 5)
                              ? (_openBlock(), _createBlock("span", _hoisted_69, " Unbaned "))
                              : (slotProps.data.status === 6)
                                ? (_openBlock(), _createBlock("span", _hoisted_70, " Info. Modified "))
                                : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Date" }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdAt)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createVNode("div", _hoisted_71, [
            _createVNode("div", _hoisted_72, [
              _hoisted_73,
              _hoisted_74,
              _createVNode("div", _hoisted_75, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.approveAccount = $event)),
                  class: "form-check-input",
                  type: "radio",
                  name: "yes-approve",
                  id: "yes-approve",
                  value: true
                }, null, 512), [
                  [_vModelRadio, _ctx.approveAccount]
                ]),
                _hoisted_76
              ]),
              _createVNode("div", _hoisted_77, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.approveAccount = $event)),
                  class: "form-check-input",
                  type: "radio",
                  name: "no-approve",
                  id: "no-approve",
                  value: false
                }, null, 512), [
                  [_vModelRadio, _ctx.approveAccount]
                ]),
                _hoisted_78
              ])
            ]),
            _createVNode("div", _hoisted_79, [
              (!_ctx.approveAccount)
                ? (_openBlock(), _createBlock("div", _hoisted_80, [
                    _withDirectives(_createVNode("textarea", {
                      placeholder: "Explain why...",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.comments = $event)),
                      class: "form-control",
                      id: "comments",
                      rows: "3"
                    }, null, 512), [
                      [_vModelText, _ctx.comments]
                    ])
                  ]))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.approveUserAccount && _ctx.approveUserAccount(...args))),
                    class: "btn btn-success mt-3"
                  }, [
                    _hoisted_81,
                    _hoisted_82
                  ]))
            ])
          ]),
          (!_ctx.approveAccount)
            ? (_openBlock(), _createBlock("div", _hoisted_83, [
                _createVNode("div", _hoisted_84, [
                  _createVNode("button", {
                    disabled: _ctx.comments.length < 4,
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.approveUserAccount && _ctx.approveUserAccount(...args))),
                    class: "btn btn-danger"
                  }, [
                    _hoisted_85,
                    _hoisted_86
                  ], 8, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_87,
          _hoisted_88,
          _createVNode("div", _hoisted_89, [
            _hoisted_90,
            _createVNode("div", _hoisted_91, [
              _hoisted_92,
              (!_ctx.selectedUser.isSuspended)
                ? (_openBlock(), _createBlock("span", _hoisted_93, " Active "))
                : (_openBlock(), _createBlock("span", _hoisted_94, "Baned")),
              _withDirectives(_createVNode("button", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openModalBanAccount && _ctx.openModalBanAccount(...args))),
                class: "btn btn-sm"
              }, [
                _hoisted_95
              ], 512), [
                [
                  _directive_tooltip,
                  'Ban account',
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode(_component_Dialog, {
                header: "Ban Account",
                visible: _ctx.banAccountModal,
                "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (_ctx.banAccountModal = $event)),
                breakpoints: { '960px': '75vw' },
                style: { width: '50vw' }
              }, {
                footer: _withId(() => [
                  _createVNode("button", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.banAccountModal = false)),
                    class: "btn btn-danger"
                  }, " Cancel "),
                  _createVNode("button", {
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.confirmBanUser && _ctx.confirmBanUser(...args))),
                    class: "btn btn-warning"
                  }, " YES, " + _toDisplayString(_ctx.selectedUser.isSuspended ? 'UNBAN' : 'BAN'), 1)
                ]),
                default: _withId(() => [
                  (!_ctx.selectedUser.isSuspended)
                    ? _withDirectives((_openBlock(), _createBlock("textarea", {
                        key: 0,
                        placeholder: "Explain why...",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.banComments = $event)),
                        class: "form-control",
                        id: "comments",
                        rows: "3"
                      }, null, 512)), [
                        [_vModelText, _ctx.banComments]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["visible"]),
              _hoisted_96,
              _hoisted_97,
              (_ctx.selectedUser.isApiTradingEnabled)
                ? (_openBlock(), _createBlock("span", _hoisted_98, [
                    _hoisted_99,
                    _withDirectives(_createVNode("button", {
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.enableAPItoken && _ctx.enableAPItoken(...args))),
                      class: "btn btn-sm"
                    }, [
                      _hoisted_100
                    ], 512), [
                      [
                        _directive_tooltip,
                        'Reset',
                        void 0,
                        { top: true }
                      ]
                    ]),
                    (_ctx.APItoken.length == 0)
                      ? _withDirectives((_openBlock(), _createBlock("button", {
                          key: 0,
                          class: "btn btn-sm",
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.getAPItoken && _ctx.getAPItoken(...args)))
                        }, [
                          _hoisted_101
                        ], 512)), [
                          [
                            _directive_tooltip,
                            'View',
                            void 0,
                            { top: true }
                          ]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("span", _hoisted_102, [
                    _hoisted_103,
                    _withDirectives(_createVNode("button", {
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.enableAPItoken && _ctx.enableAPItoken(...args))),
                      class: "btn btn-sm"
                    }, [
                      _hoisted_104
                    ], 512), [
                      [
                        _directive_tooltip,
                        'Activate',
                        void 0,
                        { top: true }
                      ]
                    ])
                  ])),
              _hoisted_105,
              (_ctx.APItoken.length > 0)
                ? (_openBlock(), _createBlock("span", _hoisted_106, " API Token: " + _toDisplayString(_ctx.APItoken), 1))
                : _createCommentVNode("", true),
              _hoisted_107,
              _hoisted_108,
              (_ctx.selectedUser.isTwoFactorAuthenticationEnabled)
                ? (_openBlock(), _createBlock("span", _hoisted_109, " Enabled "))
                : (_openBlock(), _createBlock("span", _hoisted_110, " Disabled ")),
              _withDirectives(_createVNode("button", {
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.resetTwoFactorAuth && _ctx.resetTwoFactorAuth(...args))),
                class: "btn btn-sm"
              }, [
                _hoisted_111
              ], 512), [
                [
                  _directive_tooltip,
                  'Reset',
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode(_component_ConfirmPopup)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})